import { Alert } from "@mantine/core";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { BoxContainer, Title } from "src/pages/Auth/Forms.styled";
import { useSelector } from "src/redux/hooks";

import { getCurrentVersion } from "../../../../utils";
import {
  DarkBox,
  FooterText,
  Link,
  LoginContainer,
  LoginFooter,
  LogoContainer,
} from "./AuthLayout.styled";

const isElectronApp = () => window.location.protocol === "file:";

const AuthLayout = () => {
  const { theme, origLogo } = useSelector(state => state.preferencesSlice);
  const [bridgeError, setBridgeError] = useState<string | null>(null);

  useEffect(() => {
    if (!isElectronApp()) {
      return;
    }

    const onBridgeFailed = (event: Event) => {
      const detail = (event as CustomEvent<{ message?: string }>).detail;
      setBridgeError(detail?.message ?? "Desktop bridge failed to start");
    };

    const onBridgeReady = () => {
      setBridgeError(null);
    };

    window.addEventListener("electron-api-failed", onBridgeFailed);
    window.addEventListener("electron-api-ready", onBridgeReady);

    const timeout = window.setTimeout(() => {
      if (!window.api?.sync) {
        setBridgeError(
          current =>
            current ??
            "Desktop bridge failed to start. Rebuild with yarn electron:preview.",
        );
      }
    }, 5000);

    return () => {
      window.removeEventListener("electron-api-failed", onBridgeFailed);
      window.removeEventListener("electron-api-ready", onBridgeReady);
      window.clearTimeout(timeout);
    };
  }, []);

  return (
    <LoginContainer>
      <DarkBox>
        <BoxContainer>
          {bridgeError && (
            <Alert color="red" mb="md" title="Desktop app error">
              {bridgeError}
            </Alert>
          )}
          {theme === "DSNM" ? (
            <LogoContainer>
              {origLogo && <img src="assets/eLogLogoV2.png" />}
              <img src="assets/DSNM White and Gold Logo.png" />
            </LogoContainer>
          ) : (
            <Title>LJ eLogBooks</Title>
          )}
          <Outlet />
        </BoxContainer>
        <LoginFooter>
          <Link to="/privacy-policy">Privacy policy</Link>
          <FooterText>
            © {getCurrentVersion("year")} LJ eLogbooks All rights reserved
            Version {getCurrentVersion()}
          </FooterText>
        </LoginFooter>
      </DarkBox>
    </LoginContainer>
  );
};

export default AuthLayout;
